import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef } from '@angular/material/snack-bar';

import { MpsCustomSnackbarComponent } from '../components/mps-custom-snackbar/mps-custom-snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class MpsNotificationService {
  private _duration = 2500;

  constructor(private snackBar: MatSnackBar) {}

  info = (message: string, action?: string, config?: MatSnackBarConfig): MatSnackBarRef<MpsCustomSnackbarComponent> =>
    this.openSnackbar('info', message, action, config);
  warning = (
    message: string,
    action?: string,
    config?: MatSnackBarConfig
  ): MatSnackBarRef<MpsCustomSnackbarComponent> => this.openSnackbar('warning', message, action, config);
  success = (
    message: string,
    action?: string,
    config?: MatSnackBarConfig
  ): MatSnackBarRef<MpsCustomSnackbarComponent> => this.openSnackbar('success', message, action, config);
  error = (message: string, action?: string, config?: MatSnackBarConfig): MatSnackBarRef<MpsCustomSnackbarComponent> =>
    this.openSnackbar('error', message, action, config);

  private openSnackbar = (
    type = 'info',
    message: string,
    action?: string,
    config?: MatSnackBarConfig
  ): MatSnackBarRef<MpsCustomSnackbarComponent> => {
    this._duration = ['error', 'warning', 'success'].includes(type) ? 5000 : 2500;

    config = config || new MatSnackBarConfig();

    return this.snackBar.openFromComponent(MpsCustomSnackbarComponent, {
      data: {
        message,
        action,
        config,
        type,
      },
      duration: this._duration,
    });
  };
}
